import { BsShield, BsArrowLeft } from "react-icons/bs";
import { motion } from "framer-motion";
import { useNavigate , Navigate} from "react-router-dom";

export default function Unauthorized() {
  const navigate = useNavigate();

  return (
    <div className="flex items-center justify-center  from-gray-50 to-gray-100">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="bg-white shadow-xs rounded-lg p-10 max-w-md text-center border border-gray-200"
      >
        <div className="flex justify-center mb-4">
          <div className="bg-primary-100 text-primary-600 p-4 rounded-full">
            <BsShield size={48} />
          </div>
        </div>

        <h1 className="text-2xl font-bold text-gray-600 mb-2">
          Brak uprawnień
        </h1>
        <p className="text-gray-500 mb-6">
          Nie masz dostępu do tej sekcji aplikacji.  
          Skontaktuj się z administratorem, jeśli uważasz, że to pomyłka.
        </p>

        <button
          onClick={() =>  navigate('/login', { replace: true })}
          className="inline-flex items-center px-5 py-2.5 bg-primary-700 text-white rounded-sm hover:bg-red-600 transition-all"
        >
          <BsArrowLeft className="w-4 h-4 mr-2" />
          Wróć
        </button>
      </motion.div>
    </div>
  );
}
